import { useStoreState } from 'easy-peasy';
import { useMemo } from 'react';

import { useWidgetKpiData } from '@ge/feat-reporting/data-hooks/use-widget-kpi-data';
import { useReportScope } from '@ge/feat-reporting/hooks/use-report-scope';
import { WidgetNames } from '@ge/feat-reporting/models/widgets';

export const useWidgetPerformanceSummary = ({
  config,
  endDate,
  name = WidgetNames.PERFORMANCE_SUMMARY,
  startDate,
}) => {
  const { data: kpiData, isLoading: isKpiDataLoading } = useWidgetKpiData({
    endDate,
    isActive: config?.enabled ?? true,
    includePlaceholderData: true,
    name,
    startDate,
  });

  //moving this code logic here, as we removed the operating hours value in Performance Summary as part of this defect DE213632
  const { getAssetsBySiteIds } = useStoreState((state) => state.assets);
  const { siteIds } = useReportScope();
  const assetIds = useMemo(
    () => getAssetsBySiteIds(siteIds).map(({ id }) => id),
    [getAssetsBySiteIds, siteIds],
  );
  const assetCount = assetIds?.length;

  const data = useMemo(() => {
    const kpiEntries = Object.entries(kpiData?.[name] ?? {});

    // no data so return default value
    if (!kpiEntries.length) {
      return null;
    }

    const performanceSummaryKpis = kpiEntries.reduce(
      (mapped, [kpiKey, { aggregateValue: value, units } = {}]) => {
        mapped[kpiKey] = {
          units,
          value,
        };

        return mapped;
      },
      {},
    );

    return {
      assetCount,
      data: {
        ...performanceSummaryKpis,
      },
    };
  }, [assetCount, kpiData, name]);

  const isLoading = isKpiDataLoading;

  return { data, isLoading };
};
